export const openPinnacleMessageModal = () => {
  return {
    type: "OPEN_PINNACLE_MESSAGE",
  };
};

export const closePinnacleMessageModal = () => {
  return {
    type: "CLOSE_PINNACLE_MESSAGE",
  };
};
